import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './globals.css';
import { AuthProvider } from '@/data/auth';
import { AppStateProvider } from '@/data/settings';
import { router } from '@/app/routes';

const root = document.getElementById('root');
if (!root) throw new Error('#root 가 없습니다.');

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <AppStateProvider>
        <RouterProvider router={router} />
      </AppStateProvider>
    </AuthProvider>
  </StrictMode>,
);
